// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34q5P","colMin":"styles_colMin__teWfn"};